"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Animations = void 0;
var Animations;
(function (Animations) {
    Animations["FADE_IN"] = "animate__animated animate__fadeIn";
    Animations["FADE_OUT"] = "animate__animated animate__fadeOut";
    Animations["SLIDE_IN_RIGHT"] = "animate__animated animate__slideInRight";
    Animations["SLIDE_OUT_RIGHT"] = "animate__animated animate__slideOutRight";
    Animations["SLIDE_IN_LEFT"] = "animate__animated animate__slideInLeft";
    Animations["SLIDE_OUT_LEFT"] = "animate__animated animate__slideOutLeft";
    Animations["SLIDE_IN_UP"] = "animate__animated animate__slideInUp";
    Animations["SLIDE_OUT_DOWN"] = "animate__animated animate__slideOutDown";
    Animations["ZOOM_IN"] = "animate__animated animate__zoomIn";
    Animations["FP_ZOOM_IN"] = "animate__animated fpZoomIn";
})(Animations = exports.Animations || (exports.Animations = {}));
